// src/components/ManualesModal.js
import React, { useEffect, useState } from "react";
import { FaFilePdf, FaTimes, FaDownload, FaBook } from "react-icons/fa";

export default function ManualesModal({ onClose }) {
  const [manuales, setManuales] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cargar = async () => {
      try {
        const res = await fetch("/api/manuales/mis-manuales", {
          credentials: "include",
        });
        if (!res.ok) throw new Error("Error obteniendo manuales");
        setManuales(await res.json());
      } catch (err) {
        console.error("Error cargando manuales:", err);
      } finally {
        setLoading(false);
      }
    };

    cargar();
  }, []);

  return (
    <div
      className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center z-[60] p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-6 max-h-[80vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-bold text-gray-800 flex items-center gap-2">
            <FaBook className="text-indigo-600" /> Manuales
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600" aria-label="Cerrar">
            <FaTimes />
          </button>
        </div>

        <p className="text-sm text-gray-500 mb-4">
          Manuales disponibles para los módulos a los que tienes acceso.
        </p>

        <div className="overflow-y-auto flex-1 -mx-2 px-2">
          {loading ? (
            <p className="text-sm text-slate-400 text-center py-8">Cargando manuales...</p>
          ) : manuales.length === 0 ? (
            <p className="text-sm text-slate-400 text-center py-8">No hay manuales disponibles por el momento.</p>
          ) : (
            <div className="flex flex-col gap-2">
              {manuales.map((m) => (
                <a
                  key={m.id_manual}
                  href={`${m.archivo}`}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 p-3 rounded-lg border border-slate-200 hover:bg-indigo-50 hover:border-indigo-200 transition group"
                >
                  <div className="w-9 h-9 rounded-lg bg-rose-50 text-rose-500 flex items-center justify-center shrink-0">
                    <FaFilePdf />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm font-medium text-slate-800 truncate">{m.titulo}</p>
                    <p className="text-xs text-slate-500">{m.modulo || "General"}</p>
                  </div>
                  <FaDownload className="text-slate-300 group-hover:text-indigo-500 shrink-0" />
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
